var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_setup.hasBlockUrl)?_c('span',[_vm._v(" "+_vm._s(_vm.text))]):_c('a',{attrs:{"target":"_blank","rel":"nofollow noopener noreferrer","href":_setup.blockUrl}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }